import axios from 'axios'
import _ from 'lodash'
import { Toast, Dialog } from 'vant'
import {isIosWhite} from './utils'
const debug = process.env.NODE_ENV !== 'production'
export const baseURL = CONFIG.baseUrl
    // 更改本地开发地址
    // export const baseURL = debug ? 'https://safeapi-dev.newtypegames.com/center' : 'https://safeapi-dev.newtypegames.com/center'
    // export const baseURL = debug ? 'https://safeapi-qa.newtypegames.com/center' : 'https://safeapi-qa.newtypegames.com/center'
    // export const baseURL = debug ? 'https://safeapi-dev.newtypegames.com/center' : 'https://safeapi-dev.newtypegames.com/center'
    // const baseURL = ''
const service = axios.create({
    // baseURL: 'http://192.168.105.32:8090/',
    // baseURL: 'http://10.0.2.240:8083/center',
    baseURL: baseURL,
    // baseURL: '',
    json: true,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'UA-Pixels': window.screen.width + 'x' + window.screen.height,
        'Access-Control-Allow-Credentials': false,
        'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,PATCH'
    }
})
export const ajax = {
        execute(method, vuexapi, resource, data, type, ...rest) {
            let url = resource || ''
            if (rest && Array.isArray(rest) && rest.length > 0 && rest[0].onlyValue) {
                if (Array.isArray(data)) {
                    url = `${resource}`
                    data.map(v => (url += '/' + v))
                } else {
                    url = `${resource}/${data}`
                }
            }
            const isFile = (rest && rest[0] && rest[0].isFile) || false
            const isxls = (rest && rest[0] && rest[0].isxls) || false
            const isObject = _.isObject(data)
            let config = new Object()
            if (rest && rest[0] && rest[0].isPay) {
                config = {
                    method,
                    url: url,
                    data: (!isFile && isObject && data && JSON.stringify(data)) || data || '',
                    responseType: isFile || isxls ? 'arraybuffer' : '',
                    params: method === 'GET' && isObject ? data : '',
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            } else {
                config = {
                    method,
                    url: url,
                    data: (!isFile && isObject && data && JSON.stringify(data)) || data || '',
                    responseType: isFile || isxls ? 'arraybuffer' : '',
                    params: method === 'GET' && isObject ? data : '',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    }
                }
            }
            return service(config)
                .then(res => {
                    const result = res.data
                        // 如果没有res
                        // if (!result || !result.code) {
                        //     // 捕捉错误
                        //     if (type) {
                        //         vuexapi.commit(type, {
                        //             status: 0,
                        //             errmsg: (result && result.returnMessage) || '数据异常',
                        //             content: result.data || null
                        //         })
                        //     }
                        //     return vuexapi.commit(
                        //         'ERROR_RECEIVE', {
                        //             status: 0,
                        //             errmsg: (result && result.returnMessage) || '数据异常',
                        //             content: null
                        //         }, {
                        //             root: true
                        //         }
                        //     )
                        // }
                        // 如果有res,有res.code,也有res.returnMessage
                    if (result.code === 0) {
                        // 如果存在returnMessage,也表示数据错误,需要抛出异常
                        if (type) {
                            vuexapi.commit(type, {
                                code: result.code,
                                status: 1,
                                errmsg: 0,
                                content: result.result || result.extraErrorDetail || result.reason || null,
                                count: result.count || 0,
                                requestData: data
                            })
                        }
                        return result.data
                    } else {
                        if (result.code !== -2 && result.code !== 10021 && result.code !== 10024) {
                            if (result.code == -4) {
                                Dialog.confirm({
                                        message: window.i18n.t('error-4'),
                                        cancelButtonText: window.i18n.t('cancel'),
                                        confirmButtonText: window.i18n.t('sure')
                                    })
                                    .then(() => {
                                        // if(isIosWhite()){
                                        //     window.location.href = window.location.origin + '/login?from=error'
                                        //     return
                                        // }
                                        // if (typeof(ntAndroidWeb) !== 'undefined' || (window.webkit && window.webkit.messageHandlers)) {
                                        //     typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.webClose() || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.webClose.postMessage(null))
                                        // } else {
                                            window.location.href = window.location.origin + '/login?from=error'
                                        // }
                                    })
                                    .catch(() => {
                                        //  if(isIosWhite()){
                                        //     window.location.href = window.location.origin + '/login?from=error'
                                        //     return
                                        // }
                                        // if (typeof(ntAndroidWeb) !== 'undefined' || (window.webkit && window.webkit.messageHandlers)) {
                                        //     typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.webClose() || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.webClose.postMessage(null))
                                        // } else {
                                            window.location.href = window.location.origin + '/login?from=error'
                                        // }
                                    });
                            } else {
                                Toast({
                                    message: this.errmsgShow(result.code),
                                    type: "fail"
                                })
                            }
                        }
                        if (type) {
                            vuexapi.commit(type, {
                                code: result.code,
                                status: 1,
                                errmsg: 0,
                                content: result.result || result.extraErrorDetail || result.reason || null,
                                count: result.count || 0,
                                requestData: data
                            })
                        }
                        return result.data
                    }
                })
                .catch(error => {
                    Toast({
                        message: this.errmsgShow(result.code),
                        type: "fail",
                        duration: 3000
                    })
                    if (type) {
                        vuexapi.commit(type, {
                            code: result.code,
                            status: 1,
                            errmsg: 0,
                            content: result.result || result.extraErrorDetail || result.reason || null,
                            count: result.count || 0,
                            requestData: data
                        })
                    }
                    return result.data
                })
        },
        errmsgShow(code) {
            // console.log(window.i18n.t('integral'))
            if (code === 10011) {
                return window.i18n.t('error10011')
            } else if (code === 10013) {
                return window.i18n.t('error10013')
            } else if (code === 10015) {
                return window.i18n.t('error10015')
            } else if (code === 10020) {
                return window.i18n.t('error10020')
            } else if (code === -8) {
                return window.i18n.t('error-8')
            } else if (code === -12) {
                return window.i18n.t('error-12')
            } else if (code === 1001) {
                return window.i18n.t('error1001')
            } else if (code === 1002) {
                return window.i18n.t('error1002')
            } else if (code === 1003) {
                return window.i18n.t('error1003')
            } else if (code === 1004) {
                return window.i18n.t('error1004')
            } else if (code === 1005) {
                return window.i18n.t('error1005')
            } else if (code === 1006) {
                return window.i18n.t('error1006')
            } else if (code === 1007) {
                return window.i18n.t('error1007')
            } else if (code === 1013) {
                return window.i18n.t('error1013')
            } else if (code === 1022) {
                return window.i18n.t('error1022')
            } else if (code === 1023) {
                return window.i18n.t('error1023')
            } else if (code === 1024) {
                return window.i18n.t('error1024')
            } else if (code === 1026) {
                return window.i18n.t('error1026')
            } else if (code === 1027) {
                return window.i18n.t('error1027')
            } else if (code === 1028) {
                return window.i18n.t('error1028')
            } else if (code === 1029) {
                return window.i18n.t('error1029')
            } else if (code === 1032) {
                return window.i18n.t('error1032')
            } else if (code === 1033) {
                return window.i18n.t('error1033')
            } else if (code === 1034) {
                return window.i18n.t('error1034')
            } else if (code === 2001) {
                return window.i18n.t('error2001')
            } else if (code === 2050) {
                return window.i18n.t('error2050')
            } else if (code === 2051) {
                return window.i18n.t('error2051')
            } else if (code === 2052) {
                return window.i18n.t('error2052')
            } else if (code === 2053) {
                return window.i18n.t('error2053')
            } else if (code === 2054) {
                return window.i18n.t('error2054')
            } else if (code === 2060) {
                return window.i18n.t('error2060')
            } else if (code === 2061) {
                return window.i18n.t('error2061')
            } else if (code === 2062) {
                return window.i18n.t('error2062')
            } else if (code === 3001) {
                return window.i18n.t('error3001')
            } else if (code === 4001) {
                return window.i18n.t('error4001')
            } else if (code === 4003) {
                return window.i18n.t('error4003')
            } else if (code === 4006) {
                return window.i18n.t('error4006')
            } else if (code === 4012) {
                return window.i18n.t('error4012')
            } else if (code === 4025) {
                return window.i18n.t('error4025')
            } else if (code === 4026) {
                return window.i18n.t('error4026')
            } else if (code === 4031) {
                return window.i18n.t('error4031')
            } else if (code === 4060) {
                return window.i18n.t('error4060')
            } else if (code === 6001) {
                return window.i18n.t('error6001')
            } else if (code === 6004) {
                return window.i18n.t('error6004')
            } else if (code === 6006) {
                return window.i18n.t('error6006')
            } else if (code === 6008) {
                return window.i18n.t('error6008')
            } else if (code === 6009) {
                return window.i18n.t('error6009')
            } else if (code === 7001) {
                return window.i18n.t('error7001')
            } else if (code === 10012) {
                return window.i18n.t('error10012')
            } else if (code === 10022) {
                return window.i18n.t('error10022')
            } else if (code === 10034) {
                return window.i18n.t('error10034')
            } else if (code === 10012) {
                return window.i18n.t('error10012')
            } else if (code === 10045) {
                return window.i18n.t('error10045')
            } else if (code === 10028) {
                return window.i18n.t('error10028')
            } else if (code === 10027) {
                return window.i18n.t('error10027')
            } else if (code === 10029) {
                return window.i18n.t('error10029')
            } else if (code === 10030) {
                return window.i18n.t('error10030')
            } else if (code === 10031) {
                return window.i18n.t('error10031')
            } else if (code === 10032) {
                return window.i18n.t('error10032')
            } else if (code === 10036) {
                return window.i18n.t('error10036')
            } else {
                return window.i18n.t('errorAll')
            }
        },
        post(url, vuexapi, data, mutationType) {
            return this.execute('POST', vuexapi, url, data, mutationType)
        },
        postFile(url, vuexapi, data, mutationType) {
            this.execute('POST', vuexapi, url, data, mutationType, {
                isFile: true
            })
        },
        getPay(url, vuexapi, data, mutationType) {
            this.execute('GET', vuexapi, url, data, mutationType, {
                isPay: true
            })
        },
        postPay(url, vuexapi, data, mutationType) {
            this.execute('POST', vuexapi, url, data, mutationType, {
                isPay: true
            })
        },
        get(url, vuexapi, data, mutationType) {
            return this.execute('GET', vuexapi, url, data, mutationType)
        },
        getByValue(url, vuexapi, data, mutationType) {
            return this.execute('GET', vuexapi, url, data, mutationType, {
                onlyValue: true
            })
        },
        patch(url, vuexapi, data, mutationType) {
            this.execute('PATCH', vuexapi, url, data, mutationType)
        },
        put(url, vuexapi, data, mutationType) {
            this.execute('PUT', vuexapi, url, data, mutationType)
        },
        deletePost(url, vuexapi, data, mutationType) {
            this.execute('DELETE', vuexapi, url, data, mutationType)
        },
        upload(url, vuexapi, option, mutationType) {
            const uploadUrl = `${baseURL}${url}`
            var config = {
                onUploadProgress: function(progressEvent) {
                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        // console.log(percentCompleted)
                }
            }
            const formData = new FormData()
            if (option) {
                Object.keys(option).forEach(key => {
                    const filesArray = (Array.isArray(option[key]) && (key.toLowerCase().includes('files') || key.toLowerCase().includes('file')) && option[key]) || ''
                    if ((key.toLowerCase().includes('files') || key.toLowerCase().includes('file')) && filesArray) {
                        for (let index = 0; index < filesArray.length; index++) {
                            formData.append(key, filesArray[index])
                        }
                    } else {
                        formData.append(key, option[key])
                    }
                })
                return axios
                    .post(uploadUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data;charset=utf-8'
                        },
                        config
                    })
                    .then(res => {
                        const result = res && res.data
                        const successCode = (result.code === 0 ? true : false)
                        if (successCode) {
                            if (mutationType) {
                                vuexapi.commit(mutationType, {
                                    code: result.code,
                                    status: 1,
                                    errmsg: 0,
                                    content: result.data || result.extraErrorDetail || result.reason || result.result || null
                                })
                            }
                            return res.data
                        } else {
                            if (result.code !== -2 && result.code !== 10021 && result.code !== 10024) {
                                if (result.code == -4) {
                                    Dialog.confirm({
                                            message: window.i18n.t('error-4'),
                                            cancelButtonText: window.i18n.t('cancel'),
                                            confirmButtonText: window.i18n.t('sure')
                                        })
                                        .then(() => {
                                            window.location.href = window.location.origin + '/login?from=error'
                                        })
                                        .catch(() => {
                                            window.location.href = window.location.origin + '/login?from="error'
                                        });
                                } else {
                                    Toast({
                                        message: this.errmsgShow(result.code),
                                        type: "fail"
                                    })
                                }
                            }
                            if (mutationType) {
                                vuexapi.commit(mutationType, {
                                    code: result.code,
                                    status: 1,
                                    errmsg: 0,
                                    content: result.data || result.extraErrorDetail || result.reason || result.result || null
                                })
                            }
                            return res.data
                        }
                    })
                    .catch(err => {
                        Toast({
                            message: this.errmsgShow(result.code),
                            type: "fail"
                        })
                        if (mutationType) {
                            vuexapi.commit(mutationType, {
                                code: result.code,
                                status: 1,
                                errmsg: 0,
                                content: result.data || result.extraErrorDetail || result.reason || null
                            })
                        }
                        return res.data
                    })
            }
        },
    }
    // 新加ajax请求方式，绕开vuex
export const ajaxNew = service